export const START_LOADING_APP = "START_LOADING_APP";
export const UPDATE_OPTION = "UPDATE_OPTION";
export const TOOL_COLLECTION_SELECTED = "TOOL_COLLECTION_SELECTED";
export const UPDATE_BLEED = "UPDATE_BLEED";
export const UPDATE_DESIGN_NAME = "UPDATE_DESIGN_NAME";
export const SELECT_PRINT_OPTION = "SELECT_PRINT_OPTION";
export const REPOSITION_DESIGN = "REPOSITION_DESIGN";
export const UPDATE_COLOR = "UPDATE_COLOR";
export const UPDATE_TEXT_IMAGE = "UPDATE_TEXT_IMAGE";
export const ADD_TEXT = "ADD_TEXT";
export const DELETE_TEXT = "DELETE_TEXT";
export const UPDATE_TRANSFORM_TYPE = "UPDATE_TRANSFORM_TYPE";
export const UPDATE_LETTER_SPACING = "UPDATE_LETTER_SPACING";
export const UPDATE_TRANSFORM_AMOUNT = "UPDATE_TRANSFORM_AMOUNT";
export const UPDATE_TEXT_VALUE = "UPDATE_TEXT_VALUE";
export const UPDATE_FONT_SIZE = "UPDATE_FONT_SIZE";
export const UPDATE_FONT = "UPDATE_FONT";
export const UPDATE_TEXT_DIMENSIONS = "UPDATE_TEXT_DIMENSIONS";
export const FIRST_TEXT_INITIAL_POSITION = "FIRST_TEXT_INITIAL_POSITION";
export const NEW_TEXT_INITIAL_POSITION = "NEW_TEXT_INITIAL_POSITION";
export const DROP_ELEMENT = "DROP_ELEMENT";
export const DROP_SELECTED_ELEMENTS = "DROP_SELECTED_ELEMENTS";
export const IS_DRAGGING = "IS_DRAGGING";
export const MOVE_LEFT = "MOVE_LEFT";
export const MOVE_RIGHT = "MOVE_RIGHT";
export const MOVE_UP = "MOVE_UP";
export const MOVE_DOWN = "MOVE_DOWN";
export const EXPAND_TEXT_ELEMENT = "EXPAND_TEXT_ELEMENT";
export const SHOW_DIALOG = "SHOW_DIALOG";
export const HIDE_DIALOG = "HIDE_DIALOG";
export const CHOOSE_CLIPART = "CHOOSE_CLIPART";
export const DELETE_IMAGE = "DELETE_IMAGE";
export const UPDATE_IMAGE_SIZE = "UPDATE_IMAGE_SIZE";
export const UPDATE_LATEST_CLIPART_SIZE = "LATEST_CLIPART_SIZE";
export const RESIZE_IMAGE = "RESIZE_IMAGE";
export const RESIZE_ELEMENT = "RESIZE_ELEMENT";
export const SET_ELEMENT_DIMENSIONS = "SET_ELEMENT_DIMENSIONS";
export const SET_USERART_DIMENSIONS = "SET_USERART_DIMENSIONS";
export const SELECT_SINGLE_ELEMENT = "SELECT_SINGLE_ELEMENT";
export const SELECT_MULTIPLE_ELEMENTS = "SELECT_MULTIPLE_ELEMENTS";
export const SELECT_ALL_ELEMENTS = "SELECT_ALL_ELEMENTS";
export const SET_KEY_ELEMENT = "SET_KEY_ELEMENT";
export const ALIGN_LEFT = "ALIGN_LEFT";
export const ALIGN_RIGHT = "ALIGN_RIGHT";
export const ALIGN_TOP = "ALIGN_TOP";
export const ALIGN_BOTTOM = "ALIGN_BOTTOM";
export const ALIGN_HORIZONTAL = "ALIGN_HORIZONTAL";
export const ALIGN_VERTICAL = "ALIGN_VERTICAL";
export const ALIGN_ITEMS_LEFT = "ALIGN_ITEMS_LEFT";
export const ALIGN_ITEMS_CENTER = "ALIGN_ITEMS_CENTER";
export const ALIGN_ITEMS_RIGHT = "ALIGN_ITEMS_RIGHT";
export const CENTER_ALL = "CENTER_ALL";
export const DISPLAY_SHARE = "DISPLAY_SHARE";
export const HIDE_SHARE = "HIDE_SHARE";
export const LOAD_VARIATION_WITH_OVERRIDE = "LOAD_VARIATION_WITH_OVERRIDE";
export const OVERRIDES_APPLIED = "OVERRIDES_APPLIED";
export const ROTATE_ELEMENT = "ROTATE_ELEMENT";
export const TOGGLE_ZOOM = "TOGGLE_ZOOM";
export const TOGGLE_UPLOAD_MODAL = "TOGGLE_UPLOAD_MODAL";
export const ELEMENTS_LOADED = "ELEMENTS_LOADED";
export const VALIDATE_DESIGN_ELEMENTS = "VALIDATE_DESIGN_ELEMENTS";
export const VALIDATE_ELEMENT = "VALIDATE_ELEMENT";
export const DISPLAY_INVALID_DIALOG = "DISPLAY_INVALID_DIALOG";
export const DISPLAY_LOGIN_PROMPT = "DISPLAY_LOGIN_PROMPT";
export const UPDATE_QUANTITY = "UPDATE_QUANTITY";
export const UPDATE_SAVINGS = "UPDATE_SAVINGS";
export const UPDATE_ANCHOR_POINT = "UPDATE_ANCHOR_POINT";
export const REPOSITION_ANCHORED_ELEMENT = "REPOSITION_ANCHORED_ELEMENT";
export const TOGGLE_UNIFY_TEXT = "TOGGLE_UNIFY_TEXT";
export const SET_LATEST_FONT = "SET_LATEST_FONT";
export const SET_LATEST_FONT_SIZE = "SET_LATEST_FONT_SIZE";
export const UPDATE_UNIFIED_FONT = "UPDATE_UNIFIED_FONT";
export const UPDATE_UNIFIED_FONT_SIZE = "UPDATE_UNIFIED_FONT_SIZE";
export const COPY_FROM_DESIGN_ID = "COPY_FROM_DESIGN_ID";
export const TRACK_ADMIN_ACTION = "TRACK_ADMIN_ACTION";
export const SAVE_DESIGN_RELOAD_PRICEBREAKS = "SAVE_DESIGN_RELOAD_PRICEBREAKS";
export const SET_ORIGINAL_DESIGN_ID = "SET_ORIGINAL_DESIGN_ID";
export const TOGGLE_MOBILE_DRAWER = "TOGGLE_MOBILE_DRAWER";
export const MOVE_ELEMENT = "MOVE_ELEMENT";

function action(type, payload = {}) {
  return { type, ...payload };
}

function requestTypes(entity) {
  return {
    request: (payload) => action(entity.REQUEST, { payload: payload }),
    success: (response) => action(entity.SUCCESS, { response }),
    failure: (error) => action(entity.FAILURE, { error })
  };
}

const REQUEST = "REQUEST",
  SUCCESS = "SUCCESS",
  FAILURE = "FAILURE";

function createRequestTypes(base) {
  const res = {},
    resArray = [REQUEST, SUCCESS, FAILURE];
  resArray.forEach((type) => (res[type] = `${base}_${type}`));
  return res;
}

export const PRODUCT = createRequestTypes("PRODUCT");
export const product = requestTypes(PRODUCT);

export const PRODUCTVARIATION = createRequestTypes("PRODUCTVARIATION");
export const productVariation = requestTypes(PRODUCTVARIATION);

export const PRODUCTVARIANT = createRequestTypes("PRODUCTVARIANT");
export const productVariant = requestTypes(PRODUCTVARIANT);

export const PRODUCTOPTION = createRequestTypes("PRODUCTOPTION");
export const productOption = requestTypes(PRODUCTOPTION);

export const PRODUCTVARIANTCOLORS = createRequestTypes("PRODUCTVARIANTCOLORS");
export const productVariantColors = requestTypes(PRODUCTVARIANTCOLORS);

export const DESIGN = createRequestTypes("DESIGN");
export const design = requestTypes(DESIGN);

export const SAVE_DESIGN = createRequestTypes("SAVE_DESIGN");
export const saveDesign = requestTypes(SAVE_DESIGN);

export const COPY_DESIGN = createRequestTypes("COPY_DESIGN");
export const copyDesign = requestTypes(COPY_DESIGN);

export const CREATE_PRODUCT_VARIATION = createRequestTypes(
  "CREATE_PRODUCT_VARIATION"
);
export const createProductVariation = requestTypes(CREATE_PRODUCT_VARIATION);

export const CREATE_PRODUCT = createRequestTypes("CREATE_PRODUCT");
export const createProduct = requestTypes(CREATE_PRODUCT);

export const DEFAULTFONTS = createRequestTypes("DEFAULTFONTS");
export const defaultFonts = requestTypes(DEFAULTFONTS);

export const CLIPART = createRequestTypes("CLIPART");
export const clipart = requestTypes(CLIPART);
export const CLIPART_CATEGORIES = createRequestTypes("CLIPART_CATEGORIES");
export const clipartCategories = requestTypes(CLIPART_CATEGORIES);
export const CLIPART_LIMITS = createRequestTypes("CLIPART_LIMITS");
export const clipartLimits = requestTypes(CLIPART_LIMITS);

export const ADD_DESIGN_TO_CART = createRequestTypes("ADD_DESIGN_TO_CART");
export const addDesignToCart = requestTypes(ADD_DESIGN_TO_CART);

export const CURRENTUSER = createRequestTypes("CURRENTUSER");
export const currentUser = requestTypes(CURRENTUSER);

export const UPLOAD_ART = createRequestTypes("UPLOAD_ART");
export const uploadArt = requestTypes(UPLOAD_ART);

export const USER_ART_ENTITY = createRequestTypes("USER_ART_ENTITY");
export const userArtEntity = requestTypes(USER_ART_ENTITY);

export const USER_ART = createRequestTypes("USER_ART");
export const userArt = requestTypes(USER_ART);

export const DELETE_USER_ART = createRequestTypes("DELETE_USER_ART");
export const deleteUserArt = requestTypes(DELETE_USER_ART);

export const USER_REGISTER = createRequestTypes("USER_REGISTER");
export const userRegister = requestTypes(USER_REGISTER);

export const USER_LOGIN = createRequestTypes("USER_LOGIN");
export const userLogin = requestTypes(USER_LOGIN);

export const USER_LOGOUT = createRequestTypes("USER_LOGOUT");
export const userLogout = requestTypes(USER_LOGOUT);

export const PRICE_BREAKS = createRequestTypes("PRICE_BREAKS");
export const pricebreaks = requestTypes(PRICE_BREAKS);

// Product variant selection
export const updateOption = (payload) => action(UPDATE_OPTION, { payload });
export const repositionDesign = () => action(REPOSITION_DESIGN, {});
export const verifyElementsLoaded = (payload) =>
  action(ELEMENTS_LOADED, { payload });

// Select active tool
export const selectToolCollection = (payload) =>
  action(TOOL_COLLECTION_SELECTED, { payload });

export const selectPrintOption = (payload) =>
  action(SELECT_PRINT_OPTION, { payload });

// Color selection actions
export const updateColor = (payload) => action(UPDATE_COLOR, { payload });

// Image selection actions
export const updateBleed = (payload) => action(UPDATE_BLEED, { payload });

// Type selection/transformation actions
export const addText = (payload) => action(ADD_TEXT, { payload });
export const deleteText = (payload) => action(DELETE_TEXT, { payload });
export const updateTransformType = (payload) =>
  action(UPDATE_TRANSFORM_TYPE, { payload });
export const updateLetterSpacing = (payload) =>
  action(UPDATE_LETTER_SPACING, { payload });
export const updateTransformAmount = (payload) =>
  action(UPDATE_TRANSFORM_AMOUNT, { payload });
export const updateTextValue = (payload) =>
  action(UPDATE_TEXT_VALUE, { payload });
export const updateFontSize = (payload) =>
  action(UPDATE_FONT_SIZE, { payload });
export const updateFont = (payload) => action(UPDATE_FONT, { payload });
export const updateTextDimensions = (payload) =>
  action(UPDATE_TEXT_DIMENSIONS, { payload });
export const firstTextInitialPosition = (payload) =>
  action(FIRST_TEXT_INITIAL_POSITION, { payload });
export const newTextInitialPosition = (payload) =>
  action(NEW_TEXT_INITIAL_POSITION, { payload });
export const updateTextImage = (payload) =>
  action(UPDATE_TEXT_IMAGE, { payload });

// Clipart selection actions
export const chooseClipart = (payload) => action(CHOOSE_CLIPART, { payload });
export const deleteImage = (payload) => action(DELETE_IMAGE, { payload });
export const updateImageSize = (payload) =>
  action(UPDATE_IMAGE_SIZE, { payload });
export const updateLatestClipartSize = (payload) =>
  action(UPDATE_LATEST_CLIPART_SIZE, { payload });
export const resizeImage = (payload) => action(RESIZE_IMAGE, { payload });
export const resizeElement = (payload) => action(RESIZE_ELEMENT, { payload });

export const updateDesignName = (payload) =>
  action(UPDATE_DESIGN_NAME, { payload });
export const startLoadingApp = () => action(START_LOADING_APP, {});
export const loadVariationWithOverride = (payload) =>
  action(LOAD_VARIATION_WITH_OVERRIDE, { payload });
export const overridesApplied = () => action(OVERRIDES_APPLIED, {});
export const dropElement = (payload) => action(DROP_ELEMENT, { payload });
export const dropSelectedElements = (payload) =>
  action(DROP_SELECTED_ELEMENTS, { payload });
export const checkIsDragging = (payload) => action(IS_DRAGGING, { payload });
export const moveLeft = () => action(MOVE_LEFT, {});
export const moveRight = () => action(MOVE_RIGHT, {});
export const moveUp = () => action(MOVE_UP, {});
export const moveDown = () => action(MOVE_DOWN, {});

// Show or hide dialog box
export const showDialog = (payload) => action(SHOW_DIALOG, { payload });
export const hideDialog = (payload) => action(HIDE_DIALOG, { payload });

// Align elements
export const alignTop = (payload) => action(ALIGN_TOP, { payload });
export const alignBottom = (payload) => action(ALIGN_BOTTOM, { payload });
export const alignLeft = (payload) => action(ALIGN_LEFT, { payload });
export const alignRight = (payload) => action(ALIGN_RIGHT, { payload });
export const alignHorizontal = (payload) =>
  action(ALIGN_HORIZONTAL, { payload });
export const alignVertical = (payload) => action(ALIGN_VERTICAL, { payload });
export const alignItemsLeft = (payload) =>
  action(ALIGN_ITEMS_LEFT, { payload });
export const alignItemsCenter = (payload) =>
  action(ALIGN_ITEMS_CENTER, { payload });
export const alignItemsRight = (payload) =>
  action(ALIGN_ITEMS_RIGHT, { payload });
export const centerAll = (payload) => action(CENTER_ALL, { payload });

// Select elements
export const selectSingleElement = (payload) =>
  action(SELECT_SINGLE_ELEMENT, { payload });
export const selectMultipleElements = (payload) =>
  action(SELECT_MULTIPLE_ELEMENTS, { payload });
export const selectAllElements = (payload) =>
  action(SELECT_ALL_ELEMENTS, { payload });
export const setKeyElement = ({ id, index, layerId, itemType }) => ({
  type: SET_KEY_ELEMENT,
  payload: { id, index, layerId, itemType }
});

// Set element width and height
export const setElementDimensions = (payload) =>
  action(SET_ELEMENT_DIMENSIONS, { payload });
export const setUserArtDimensions = (payload) =>
  action(SET_USERART_DIMENSIONS, { payload });

// Display the Sharing dialog
export const displayShare = () => action(DISPLAY_SHARE, {});
export const hideShare = () => action(HIDE_SHARE, {});

// Rotate elements
export const rotateElement = (payload) => action(ROTATE_ELEMENT, { payload });

// Display Zoom modal
export const toggleZoom = (payload) => action(TOGGLE_ZOOM, { payload });

// Toggle Upload modal
export const toggleUploadModal = (payload) =>
  action(TOGGLE_UPLOAD_MODAL, { payload });

// Verify that all elements fit within design's printable area
export const validateDesign = () => action(VALIDATE_DESIGN_ELEMENTS, {});
export const validateElement = (payload) =>
  action(VALIDATE_ELEMENT, { payload });
export const displayInvalidDialog = (payload) =>
  action(DISPLAY_INVALID_DIALOG, { payload });

// Display login prompt when saving if not logged in
export const displayLoginPrompt = (payload) =>
  action(DISPLAY_LOGIN_PROMPT, { payload });

// Keep track of selected product quantity
export const updateQuantity = (payload) => action(UPDATE_QUANTITY, { payload });
export const updateSavings = (payload) => action(UPDATE_SAVINGS, { payload });

// Add anchor points to text
export const updateAnchorPoint = (payload) =>
  action(UPDATE_ANCHOR_POINT, { payload });
export const repositionAnchoredElement = (payload) =>
  action(REPOSITION_ANCHORED_ELEMENT, { payload });

// Unify Text
export const toggleUnifyText = (payload) =>
  action(TOGGLE_UNIFY_TEXT, { payload });
export const setLatestFont = (payload) => action(SET_LATEST_FONT, { payload });
export const setLatestFontSize = (payload) =>
  action(SET_LATEST_FONT_SIZE, { payload });
export const updateUnifiedFont = (payload) =>
  action(UPDATE_UNIFIED_FONT, { payload });
export const updateUnifiedFontSize = (payload) =>
  action(UPDATE_UNIFIED_FONT_SIZE, { payload });

// Copy from another design
export const copyFromDesign = (payload) =>
  action(COPY_FROM_DESIGN_ID, { payload });

// track when an admin is trying to edit/copy an already ordered design
export const trackAdminAction = (payload) =>
  action(TRACK_ADMIN_ACTION, { payload });

export const saveDesignReloadPricebreaks = (payload) =>
  action(SAVE_DESIGN_RELOAD_PRICEBREAKS, { payload });

export const setOriginalDesignId = (payload) =>
  action(SET_ORIGINAL_DESIGN_ID, { payload });

// Add new action type for mobile drawer
export const toggleMobileDrawer = (isOpen) => {
  return {
    type: TOGGLE_MOBILE_DRAWER,
    payload: {
      isOpen
    }
  };
};

export const moveElement = (payload) => action(MOVE_ELEMENT, { payload });
